/** Textes « photosEdl » — le français fait foi. */
export const photosEdl = {
  titre: 'Photos du véhicule',
  retirer: 'retirer',
  erreurImage: "Cette image n'a pas pu être traitee. Reessayez.",
  explication: (ko: number) => `Chaque photo est réduite à 1600 px et compressée sur le téléphone (${ko} Ko au total). C'est ce qui évite de remplir le serveur — et ce qui vous fera gagner un litige.`,
  /** Les six prises de vue du contrat (lib/photos). */
  vues: {
    avant: 'Avant', arriere: 'Arrière', cote_gauche: 'Côté gauche', cote_droit: 'Côté droit',
    interieur: 'Intérieur', compteur: 'Compteur',
  },
  /** Messages d'envoi (lib/photos). */
  compressionImpossible: 'Compression impossible',
  tropLourde: 'Photo trop lourde pour être envoyée.',
  tropLent: 'Connexion trop lente — réessayez près du bureau.',
  envoiImpossibleCode: (code: number) => `Envoi impossible (${code})`,
  envoiPhotosImpossible: 'Envoi des photos impossible',
};
